import { createListenerMiddleware } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import { currentStoreChanged, sessionCleared } from '@/shared/lib/redux/actions';

/** Switching the active store (or signing out) invalidates every per-store RTK Query cache entry
 *  — otherwise a screen could briefly render the previous store's data under the new store's
 *  X-Store-Id (docs/PLAN.md §6 "переключение магазина → resetApiState"). */
export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: currentStoreChanged,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

listenerMiddleware.startListening({
  actionCreator: sessionCleared,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});
